import TagItem from './TagItem';

function TagList({tagList}) {
  return (
    <div className="item-tags">
      {
        tagList.map((tag, index) =>(
          <TagItem eachTag={tag} index={index} key={ index }/>
        ))
      }
    </div>
  );
}

export default TagList;